import { GreyGrey30, Box } from '@sequencehq/core-components'

export const ProductGraphDivider = () => (
  <Box width="1px" height="100%" margin="0 24px" background={GreyGrey30}></Box>
)
